import React, { FC } from 'react'

import { Chip, ChipProps } from '@Components/Chips/Chip/Chip'
import { useTranslation } from '@Globals/Translations'

export const NewChip: FC<ChipProps> = ({ size = 'medium' }) => {
  const { t } = useTranslation()
  return (
    <Chip color="blue" size={size}>
      {t('common:BADGE_NEW_LABEL')}
    </Chip>
  )
}
